// React Imports
import { useEffect, useState } from "react";

// Router Imports
import { useNavigate } from "react-router-dom";

// Utils Imports
import { GlobalConfiguration } from "../../../utils/configurationProvider";

// Component Imports
import ICONS from "../../../assets/Icons";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import { useDispatch } from "react-redux";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const ReimbursementTxnMultiApprovalDeclined = () => {
  // 1️⃣ useNavigate
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 2️⃣ useState
  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);

  // 3️⃣ Callback / Handler functions
  const buttonRows = [
    [
      {
        btnText: "Approve more transactions",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/reimbursement_transaction_dashboard/reimbursement_transaction_multi_approval",
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/beneficiary_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions?.map((account, i) => (
        <InfoCard
          key={account?.txn_id || i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: account?.beneficiary_account_name,
              leftSubTitle: "Account name",
              rightTitle: (
                <>
                  INR <FormatAmount price={account?.amount} />
                </>
              ),
              rightSubTitle: "Amount",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              hasRight: true,
              rightIcon: false,
              rightText: true,
              onClick: () =>
                navigate(
                  `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                ),
            },
          ]}
        />
      ))}
    </div>
  );

  // 4️⃣ useEffect
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementTxnData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
      setdeclinedPageID(storedSelectedApproval?.selectedTransactions);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);
  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <StatusContainer
      status="success"
      buttonRows={buttonRows}
      title={declinedPageID?.length && "Transactions rejected successfully."}
    >
      <TabsWeapperSection
        title={`Rejected transactions  - ${
          declinedPageID?.length || declinedPageData?.length
        }`}
      >
        <TransactionList transactions={declinedPageData} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default ReimbursementTxnMultiApprovalDeclined;
